import { cn } from '@/lib/utils';

export default function ActivityLogMessage({ message }) {
  if (!message || message.message_type !== 'activity_log') {
    return null;
  }

  return (
    <div className='relative mx-10 my-5 flex items-center justify-center'>
      <div className='absolute left-0 right-0 -z-10 w-full border-t border-border' />
      <span
        className={cn(
          'rounded-md bg-border px-4 py-2 text-xs text-muted-foreground'
        )}
      >
        {message.text}
      </span>
    </div>
  );
}
